import { INTENSJON_QUERY_PARAM, OPPGAVE_RETURURL_QUERY_PARAM, OPPGAVEID_QUERY_PARAM } from '@utils/constants';
import { isGuid } from '@utils/utils';

export const extractOppgaveIdFromPathname = (): string | undefined => {
  let oppgaveId: string | undefined = undefined;
  const params = new URLSearchParams(location.search);
  for (const [name, value] of params) {
    if (name.toLowerCase() === OPPGAVEID_QUERY_PARAM) {
      oppgaveId = value;
    }
  }
  return !!oppgaveId && isGuid(oppgaveId) ? oppgaveId : undefined;
};

export const extractIntensjonFromPathname = (): string | undefined => {
  let intensjon: string | undefined = undefined;
  const params = new URLSearchParams(location.search);
  for (const [name, value] of params) {
    if (name.toLowerCase() === INTENSJON_QUERY_PARAM) {
      intensjon = value;
    }
  }
  return intensjon;
};

export const extractOppgaveReturUrlFraPathname = (): string => {
  let retururl = '';
  const params = new URLSearchParams(location.search);
  for (const [name, value] of params) {
    if (name.toLowerCase() === OPPGAVE_RETURURL_QUERY_PARAM) {
      retururl = decodeURIComponent(value);
    }
  }
  return retururl;
};

export const innbyggerHarMottattVerktoyOppgave = (): boolean => {
  const oppgaveId = extractOppgaveIdFromPathname();
  const retururl = extractOppgaveReturUrlFraPathname();
  return !!(oppgaveId && retururl);
};

export const getOppgaveReturnUrl = (): string => {
  const retururl = extractOppgaveReturUrlFraPathname();
  return retururl ? `${window.location.origin}${retururl}` : '';
};
